import SafeDrivingTermsContentsEu from '@di-shared/features/safe-driving/eu/SafeDrivingTermsContents.eu';
import {Suspense} from 'react';

export interface SafeDrivingTermsPageProps {
  vin: string;
}

function SafeDrivingTermsPage({vin}: SafeDrivingTermsPageProps) {
  return (
    <Suspense fallback={<SafeDrivingTermsContentsEu.Loading />}>
      <SafeDrivingTermsContentsEu vin={vin} />;
    </Suspense>
  );
}

export default SafeDrivingTermsPage;
